import { validatePreparedAudio } from "./playlist-audio.js";
export const startupSoundPath="/branding/startup.wav";
export function validateStartupSound(audio){
  const seconds=validatePreparedAudio(audio?.bytes);
  if(seconds>5||audio.bytes.length>327680)throw new Error("Choose a startup sound of five seconds or less. The original has not been shortened.");
  if(!/^[a-f0-9]{64}$/i.test(audio.hash??""))throw new Error("The prepared startup sound is missing its verified hash.");
  return seconds;
}
export function startupSoundCommand(enabled,assetId=null){
  if(typeof enabled!=="boolean"||(enabled?!/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(assetId??"")||/^0{8}-0{4}-0{4}-0{4}-0{12}$/.test(assetId):assetId!==null))
    throw new Error("Choose a prepared startup sound, or None.");
  return {action:"startupSound",enabled,assetId};
}
export function confirmStartupSound(state,enabled){
  if(state?.startupSound?.enabled!==enabled||typeof state.startupSound.error!=="string"||state.startupSound.error)
    throw new Error(state?.startupSound?.error||"Pirdy did not confirm its startup sound. Refresh before retrying.");
  return state;
}
